import React, { Component } from "react";
import "./App.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
import BrandList from "./components/brand/brand.list.component";
import MergeBrand from "./components/merge_brands/merge.brand.component";
import BrandAdd from "./components/brand/brand.add.component";
import LocationList from "./components/location/location.list.component";
import LocationAdd from "./components/location/location.add.component";
import AdvertisementList from "./components/advertisement/advertisement.list.component";
import AdvertisementAdd from "./components/advertisement/advertisement.add.component";
import MediaList from "./components/media/media.list.component";
import MediaAdd from "./components/media/media.add.component";
import ProductList from "./components/product/product.list.component";
import ProductAdd from "./components/product/product.add.component";
import ConfigPage from "./components/config-page.component";
import AnalyticList from "./components/analytic.component";
import AppBar from "./components/common_components/app_bar.component";
import BrandApplicationList from "./components/brand_application/brand.list.component";
import BrandApplicationView from "./components/brand_application/brand.view.component";
import ReportList from "./components/report.list.component";
import axios from "axios";

const drawerWidth = 240;

const styles = (theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  toolbar: theme.mixins.toolbar,
  selected: {
    "&$selected": {
      backgroundColor: "#F6277F",
      color: "white",
    },
    "&:hover": {
      color: "white !important",
      backgroundColor: "#c41b63 !important",
    },
  },
});

class MainPage extends Component {
  state = {
    open: true,
    selectedIndex: 0,
  };

  constructor(props) {
    super(props);
    //this.handleListItemClick = this.handleListItemClick.bind(this);
  }

  componentDidMount() {
    document.title = "CanaWho";
  }

  componentWillMount() {
    if (!axios.defaults.headers.common["Authorization"]) {
      this.props.history.push("/login");
    }
  }

  handleClick = () => {
    this.setState((state) => ({ open: !state.open }));
  };

  handleListItemClick = (index) => {
    this.setState({ selectedIndex: index });
  };

  render() {
    const { classes } = this.props;

    return (
      <Router>
        <AppBar />
        <Grid container spacing={12} style={{ marginTop: "5%" }}>
          <Grid item xs={3} style={{ paddingLeft: "2%", marginRight: "-2%" }}>
            <Paper style={{ width: "80%" }}>
              <List component="nav" className={classes.root}>
                <ListItem
                  button
                  component={Link}
                  to="/admin/brand"
                  selected={this.state.selectedIndex === 0}
                  classes={{ selected: classes.selected }}
                  onClick={() => this.handleListItemClick(0)}
                >
                  <ListItemText primary="Brand / Product" />
                </ListItem>
                <ListItem
                  button
                  component={Link}
                  to="/admin/mergebrand"
                  selected={this.state.selectedIndex === 1}
                  classes={{ selected: classes.selected }}
                  onClick={() => this.handleListItemClick(1)}
                >
                  <ListItemText primary="Merge Brands" />
                </ListItem>
                <ListItem
                  button
                  component={Link}
                  to="/admin/advertisement"
                  selected={this.state.selectedIndex === 2}
                  classes={{ selected: classes.selected }}
                  onClick={() => this.handleListItemClick(2)}
                >
                  <ListItemText primary="Advertisement" />
                </ListItem>

                <ListItem
                  button
                  component={Link}
                  to="/admin/media"
                  selected={this.state.selectedIndex === 3}
                  classes={{ selected: classes.selected }}
                  onClick={() => this.handleListItemClick(3)}
                >
                  <ListItemText primary="Media" />
                </ListItem>

                <ListItem
                  button
                  component={Link}
                  to="/admin/location"
                  selected={this.state.selectedIndex === 4}
                  classes={{ selected: classes.selected }}
                  onClick={() => this.handleListItemClick(4)}
                >
                  <ListItemText primary="Location" />
                </ListItem>

                <ListItem
                  button
                  component={Link}
                  to="/admin/brand-application"
                  selected={this.state.selectedIndex === 5}
                  classes={{ selected: classes.selected }}
                  onClick={() => this.handleListItemClick(5)}
                >
                  <ListItemText primary="Brand Applications" />
                </ListItem>

                <ListItem
                  button
                  component={Link}
                  to="/admin/report"
                  selected={this.state.selectedIndex === 6}
                  classes={{ selected: classes.selected }}
                  onClick={() => this.handleListItemClick(6)}
                >
                  <ListItemText primary="Report" />
                </ListItem>

                <ListItem
                  button
                  component={Link}
                  to="/admin/config"
                  selected={this.state.selectedIndex === 7}
                  classes={{ selected: classes.selected }}
                  onClick={() => this.handleListItemClick(7)}
                >
                  <ListItemText primary="Configurations" />
                </ListItem>

                <ListItem
                  button
                  component={Link}
                  to="/admin/analytics"
                  selected={this.state.selectedIndex === 8}
                  classes={{ selected: classes.selected }}
                  onClick={() => this.handleListItemClick(8)}
                >
                  <ListItemText primary="Analytics" />
                </ListItem>
              </List>
            </Paper>
          </Grid>
          <Grid item xs={9} style={{ paddingRight: 30 }}>
            <Paper>
              <Switch>
                <Route exact path="/admin" component={BrandList} />
                <Route exact path="/admin/brand" component={BrandList} />
                <Route exact path="/admin/mergebrand" component={MergeBrand} />
                <Route exact path="/admin/brand/add" component={BrandAdd} />
                <Route
                  exact
                  path="/admin/brand/edit/:id"
                  component={BrandAdd}
                />
                <Route
                  exact
                  path="/admin/product/:brandId"
                  component={ProductList}
                />
                <Route
                  exact
                  path="/admin/product/add/:brandId"
                  component={ProductAdd}
                />
                <Route
                  exact
                  path="/admin/product/edit/:brandId/:id"
                  component={ProductAdd}
                />
                <Route
                  exact
                  path="/admin/advertisement"
                  component={AdvertisementList}
                />
                <Route
                  exact
                  path="/admin/advertisement/add"
                  component={AdvertisementAdd}
                />
                <Route
                  exact
                  path="/admin/advertisement/edit/:id"
                  component={AdvertisementAdd}
                />
                <Route exact path="/admin/media" component={MediaList} />
                <Route exact path="/admin/media/add" component={MediaAdd} />
                <Route
                  exact
                  path="/admin/media/edit/:id"
                  component={MediaAdd}
                />
                <Route exact path="/admin/location" component={LocationList} />
                <Route
                  exact
                  path="/admin/location/add"
                  component={LocationAdd}
                />
                <Route
                  exact
                  path="/admin/location/edit/:id"
                  component={LocationAdd}
                />
                <Route
                  exact
                  path="/admin/brand-application"
                  component={BrandApplicationList}
                />
                <Route
                  exact
                  path="/admin/brand-application/view/:id"
                  component={BrandApplicationView}
                />
                <Route exact path="/admin/report" component={ReportList} />
                <Route exact path="/admin/config" component={ConfigPage} />
                <Route exact path="/admin/analytics" component={AnalyticList} />
              </Switch>
            </Paper>
          </Grid>
        </Grid>
      </Router>
    );
  }
}

MainPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainPage);
